import { Link } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button, buttonVariants } from "@/components/ui/button";
import { useAuth } from "@/lib/auth-context";

export default function LockedPage() {
  const { lockedReason, logout } = useAuth();
  const reason = lockedReason === "inactive" ? "prolonged inactivity" : "security reasons";

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-lg items-center p-6" data-page="locked">
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Account locked</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <p>
            Your account has been locked due to {reason}. If you believe this is a
            mistake, please contact your school administrator or reset your
            password below.
          </p>
          <div className="flex gap-2 pt-2">
            <Link to="/reset-password" className={buttonVariants({ variant: "default", size: "sm" })}>
              Reset password
            </Link>
            <Button variant="outline" size="sm" onClick={logout}>
              Sign out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
